export default "__VITE_ASSET__DvAb8UBU__"